import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { customerWriteBody, mapCustomerRecordSnCodes } from './snCodeWire';

/**
 * 建立客戶。
 * `POST /crm/customer` → 201；預設 ACTIVE；**不送** status。
 * addresses／contacts 可為 []；子列不帶 id。
 *
 * @param {object} payload — camelCase
 */
export async function createCustomer(payload) {
  const { data: raw } = await request.post('/crm/customer', customerWriteBody(payload));
  const parsed = parseVer4DetailResponse(raw);
  return { ...parsed, data: mapCustomerRecordSnCodes(parsed.data) };
}
